import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Form, Row, Col, Container } from 'react-bootstrap';

import { Address } from '../FormFields/Address';
import { PhoneNumber } from '../FormFields/PhoneNumber';
import { pyroCompanySchema } from '../../schemas/pyroCompanySchema';
import { ControlButtons } from '../ControlButtons';

export const PyrotechnicsCompany = ({
	currPyroCompany = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const { register, handleSubmit, formState } = useForm({
		resolver: yupResolver(pyroCompanySchema),
		defaultValues: currPyroCompany,
	});

	return (
		<Container className="component">
			<Container className="p-0 mt-5 component">
				<h2 className="mb-4">Company Information</h2>
				<Row>
					<Form.Group as={Col} xs="12" md="10" className="mb-3">
						<Form.Label>Pyrotechnics Company</Form.Label>
						<Form.Control type="text" autoFocus {...register('name')} />
						<Form.Text className="text-danger">
							{formState.errors.name?.message}
						</Form.Text>
					</Form.Group>

					<Form.Group as={Col} xs="12" md="2">
						<Form.Label>Phone Number</Form.Label>
						<PhoneNumber register={register} />
						<Form.Text className="text-danger">
							{formState.errors.phone?.message}
						</Form.Text>
					</Form.Group>
				</Row>

				<Address register={register} error={formState.errors}></Address>

				<Row>
					<Col>
						<Form.Group className="mb-3">
							<Form.Label>Pyrotechnics Operator</Form.Label>
							<Form.Control type="text" {...register('operator')} />
							<Form.Text className="text-danger">
								{formState.errors.operator?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>
				<Row>
					<Col>
						<Form.Group className="mb-3">
							<Form.Label>State Licence Number</Form.Label>
							<Form.Control type="number" {...register('license')} />
							<Form.Text className="text-danger">
								{formState.errors.license?.message}
							</Form.Text>
						</Form.Group>
					</Col>
				</Row>
			</Container>

			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				disablePrev={disablePrev}
				disableNext={disableNext}
				finalStep={finalStep}
			/>
		</Container>
	);
};
